//Now: Fix the inputs and span mismatch in Element.js (2 hours)
//Now: Task 'jump to' on right side (i'd like to jump right to node when looking at task) - need this, this is a gap in UX (30 mins)
//Now: Fix the due date in tasks and also the date in completed (15 mins)
//Now: Allow tasks to optionally have date and/or task (2 hours)
//Later: Breadcrumbs on tasks should only be shown on task mouseover


//Later: Hmm, it would be nice to add a reminder which basically is a task that comes on at a later date. 
//Later: Pick any node and that node can become a task LIST such that any descendent task will be shown on that list
//Later: Notify when deleting a task (prevent it?)
//Later: Ctrl+T search around via text


//Later: Add export/import feature
//Later: Ability ot update date of task
//Later: Different sheets
//Later: Implement Undo
//Later: Ability to resize or hide the task sidebar (Matt)
//Later: Must refactor and use state/remote persistence
//Later: Save expand/collapse to firebase
//Later: Need to make sure to protect against concurrent updates to maxId (could break db structure)
//Later: Ability to Move nodes around
//Later: Sort children of node (in options menu)

//Matt: Unclear how Now/Later works (based on date or curated) - maybe i should just remove and make it one list
//Seth: Fix hierarchy views for deep tasks or long text tasks
//Seth: Tag a note to completed (anything to note of?). Hmm. 
//Seth: Would want to be able to customize the left sidebar with color options. Option to flip or move the left hand task dashboard (vertical versus horizontal/ top/ bottom/ right).

//Bug:  Limit task text with elipsis (overflowing)

import React from 'react';
import './App.css';
import Element from './Element.js';
import Task from './Task.js';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {auth, firestore} from './firebase';
import firebase from 'firebase/app';
import moment from 'moment';
import {ButtonGroup, Button, IconButton} from '@material-ui/core';
import {ToggleButton, ToggleButtonGroup} from '@material-ui/lab';
import SearchIcon from '@material-ui/icons/Search';
import Tooltip from '@material-ui/core/Tooltip';
import Key from "./ShortcutKey.js";
import ellipsis from './ellipsis.svg';
import { Menu, Item, Separator, Submenu, MenuProvider, contextMenu } from 'react-contexify';
import Migrate from './Migrate.js';
import { Link } from 'react-router-dom';
import Fuse from 'fuse.js'

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  // padding: grid * 2,
  margin: `0 0 2px 0`,
  borderRadius: '5px',
  // change background colour if dragging
  background: isDragging ? "rgb(255,255,255,0.3)" : "rgb(255,255,255,0.5)",

  // styles we need to apply on draggables
  ...draggableStyle
});

var TEMP_ID = null;
var TEMP_TIME = null;


function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`
  };
}


class App extends React.Component {

  constructor(props) {
    super(props);
    var date = new Date();
    date.setDate(date.getDate() + 1);

    let tree = {  rootId: 1, 
                  maxId: 8,
                  maxTaskListId: 4,
                  startFocusId: 1,
                  taskLists: {0: {id: 0, name: "", taskOrder: []}, 1: {id: 1, name: "Important and Urgent", taskOrder: [8]}, 2: {id: 2, name: "Important and Not Urgent", taskOrder: []}, 3: {id: 3, name: "Not Important and Urgent", taskOrder: []}, 4: {id: 4, name: "Not Important and Not Urgent", taskOrder: []} },
                  taskListOrder: [1,2,3,4],
                  completedTasks: [],
                  1: {id: 1, t: null, kids: [2], parentId: null, expand: true},
                  2: {id: 2, t: 'Movies', kids: [3,4], parentId: 1, expand: true},    
                  3: {id: 3, t: 'Secret Life of Pets', kids: [5,6], parentId: 2, expand: true},    
                  4: {id: 4, t: 'Matrix', kids: [7],isRootNode: true, parentId: 2, expand: true},    
                  5: {id: 5, t: 'Snowball', kids: [], parentId: 3, expand: true},    
                  6: {id: 6, t: 'Max', kids: [], parentId: 3, expand: true}, 
                  7: {id: 7, t: 'Neo', kids: [8], parentId: 4, expand: true},
                  8: {id: 8, t: 'Knock knock neo...', kids: [], parentId: 7, expand: true, due: new firebase.firestore.Timestamp(moment(date).unix(),0), complete: false},
                };

    this.state = {tree: null, 
                  viewRootId: null, 
                  zoomAncestorIds: [], 
                  focusObjId: null, 
                  filteredNowTaskOrder: [],
                  filteredLaterTaskOrder: [],
                  focus: true, 
                  focusSelectionStart: 0, 
                  focusSelectionEnd: 0, 
                  showTasks: true, 
                  completedFilter: 'today',
                  showHelp: false, 
                  taskListEdit: null, 
                  showSearch: false,
                  searchResults: [], 
                  searchText: ""}

    this.updateObj = this.updateObj.bind(this);
    this.setFocus = this.setFocus.bind(this);
    this.findNextNodeUp = this.findNextNodeUp.bind(this);
    this.findNextNodeDown = this.findNextNodeDown.bind(this);
    this.insert = this.insert.bind(this);
    this.renderTasks = this.renderTasks.bind(this);
    this.renderCompleted = this.renderCompleted.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.parentsTextArray = this.parentsTextArray.bind(this);
    this.getAllDescendents = this.getAllDescendents.bind(this);
    this.loadTree = this.loadTree.bind(this)
    this.saveTaskListName = this.saveTaskListName.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);
    this.hideSearch = this.hideSearch.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.search = this.search.bind(this);
    this.getAncestorIds = this.getAncestorIds.bind(this);
    //DANGER DANGER DANGER
    // firestore.doc(`users/${this.props.user.uid}`).set({tree: tree});
    //DANGER DANGER DANGER
  }

  componentDidMount() {
    this.loadTree();
    document.addEventListener('keydown', this.handleKeyDown);
  }

  async loadTree() {
    
    var tree;
    if (!this.props.demo) { 
   
      var test = await firestore.doc(`users/${this.props.user.uid}`).get();
      var data = test.data();
      data = Migrate(data, this.props.user.uid);
      tree = data.tree;
      

    } else {
      var date = new Date();
      date.setDate(date.getDate() + 1);
      tree = {  rootId: 1, 
                  maxId: 10,
                  maxTaskListId: 2,
                  startFocusId: 1,
                  taskLists: {0: {id: 0, name: "", taskOrder: []}, 1: {id: 1, name: "Urgent", taskOrder: [11,8]}, 2: {id: 2, name: "Later is Fine", taskOrder: []}, },
                  taskListOrder: [1,2],
                  completedTasks: [],
                  1: {id: 1, t: null, kids: [2], parentId: null, expand: true},
                  2: {id: 2, t: 'Work', kids: [3,4], parentId: 1, expand: true},    
                  3: {id: 3, t: 'Projects', kids: [5], parentId: 2, expand: true},    
                  4: {id: 4, t: 'Administrative', kids: [7],isRootNode: true, parentId: 2, expand: true},    
                  5: {id: 5, t: 'Project X', kids: [9,6], parentId: 3, expand: true},    
                  6: {id: 6, t: 'Meeting Notes', kids: [11], parentId: 5, expand: true}, 
                  7: {id: 7, t: 'Fix coffee machine', kids: [8], parentId: 4, expand: true},
                  8: {id: 8, t: 'Call coffee machine repair company', kids: [], parentId: 7, expand: true, due: new firebase.firestore.Timestamp(moment(date).unix(),0), complete: false},
                  9: {id: 9, t: 'Goals', kids: [10], parentId: 5, expand: true},
                  10: {id: 10, t: 'Marketing reboot for 2020', kids: [], parentId: 9, expand: true, due: new firebase.firestore.Timestamp(moment(date).unix(),0), complete: false},
                  11: {id: 11, t: 'Update spreadsheet for meeting', kids: [], parentId: 6, expand: true, due: new firebase.firestore.Timestamp(moment(date).unix(),0), complete: false},

                };


    }


    this.setState({tree: tree, focusObjId: tree.rootId, viewRootId: tree.startFocusId ,  focus: true, focusSelectionStart: 0, focusSelectionEnd: 0, })
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    //TODO: Need to treat the current filtered list and indices different from the overall ordered, non-filtered list

    var tempTree = this.state.tree;
    var indexOfDelete;
    
    var taskOrder = tempTree.taskLists[result.destination.droppableId].taskOrder;
    var taskOrderSource = tempTree.taskLists[result.source.droppableId].taskOrder;
    var idsInView = this.getAllDescendents(this.state.viewRootId);
    var filteredTaskOrder = taskOrder.filter(x => idsInView.includes(x)); 

    //I guess we can just delete the draggableId to keep it easy
    // console.log("Source Task Order (before): " + taskOrderSource)
    if (result.source.droppableId === result) {
      indexOfDelete = taskOrderSource.indexOf(parseInt(result.draggableId))
      taskOrderSource.splice(indexOfDelete, 1);
    } else {
      indexOfDelete = taskOrderSource.indexOf(parseInt(result.draggableId))
      taskOrderSource.splice(indexOfDelete, 1);
    }
    // console.log("Source Task Order (after): " + taskOrderSource)
    
    //ok we killed it from the main source task order list
    // console.log("tempTree.nowTaskOrder: " + tempTree.nowTaskOrder)
    // console.log("state.filteredNowTaskOrder: " + filteredNowTaskOrder)
    

    //Need to find the id of the item below destination and place it in the spot just ahead of it
    //what do we do if no items below it? put it at the bottom of the overall? maybe.
    //a good rule is that any drag and drop cannot outrank anything not on this list unless via transitive property
    

    // console.log("Destination Task Order (before): " + taskOrder)

    if (taskOrder.length === 0) {
      taskOrder.push(parseInt(result.draggableId));
    } else {
      var justLessObjId;
      if (result.destination.droppableId === result.source.droppableId) {
        if (result.destination.index === filteredTaskOrder.length -1) {
          taskOrder.push(parseInt(result.draggableId));  //WORKS
        } else {
          if (result.destination.index > result.source.index) { 
            justLessObjId = filteredTaskOrder[result.destination.index]+1;
          } else {
            justLessObjId = filteredTaskOrder[result.destination.index];
          }
          // console.log("object just previous to new position is " +justLessObjId)
          var newIndex = taskOrder.indexOf(justLessObjId);
          // console.log("adding " + result.draggableId + " to " + tempTree.nowTaskOrder + " at index " + newIndex)
          taskOrder.splice(newIndex, 0, parseInt(result.draggableId));  
        }

      } else {
        if (result.destination.index == filteredTaskOrder.length) {
          taskOrder.push(parseInt(result.draggableId));  //WORKS
        } else {
          justLessObjId = filteredTaskOrder[result.destination.index];
          // console.log("object just previous to new position is " +justLessObjId)
          var newIndex = taskOrder.indexOf(justLessObjId);
          // console.log("adding " + result.draggableId + " to " + tempTree.nowTaskOrder + " at index " + newIndex)
          taskOrder.splice(newIndex, 0, parseInt(result.draggableId)); 
        }
      }
    }

    // console.log("Destination Task Order (after): " + taskOrder)

    //Firestore Updates
    if (!this.props.demo) {
      var updates = {};
      updates[`tree.taskLists.${result.destination.droppableId}.taskOrder`] = tempTree.taskLists[result.destination.droppableId].taskOrder;
      updates[`tree.taskLists.${result.source.droppableId}.taskOrder`] = tempTree.taskLists[result.source.droppableId].taskOrder;
      firestore.doc(`users/${this.props.user.uid}`).update(updates);
    }

      tempTree.taskLists[result.destination.droppableId].taskOrder = taskOrder;
      tempTree.taskLists[result.source.droppableId].taskOrder = taskOrderSource;

      this.setState({tree: tempTree, placeholder: {} })
 
  }

  

  moveObj(id, fromParentId, toParentId) {

  }

  setFocus(id, focus, focusSelectionStart, focusSelectionEnd) {
    this.setState({focusObjId: id, focus: focus, focusSelectionStart: focusSelectionStart, focusSelectionEnd: focusSelectionEnd})
  }

  //////////////////////
  //VIEW MANIPULATION
  //////////////////////

  findNextNodeUp(objId){
    let obj = this.state.tree[objId];
    let indexOfObjInParentsKids = this.state.tree[obj.parentId].kids.indexOf(objId);

    if (indexOfObjInParentsKids > 0 ) { //if sibling above 
      var nextObj = this.state.tree[this.state.tree[obj.parentId].kids[indexOfObjInParentsKids-1]]
      while (nextObj.kids.length > 0 && nextObj.expand) {
        nextObj = this.state.tree[nextObj.kids[nextObj.kids.length-1]]
      }
      return nextObj.id;
    } else { //if no sibling above, go to parent  
      return obj.parentId;
    }
  }


  //Buggy for long branches
  findNextNodeDown(objId){
    let obj = this.state.tree[objId];
    let indexOfObjInParentsKids = this.state.tree[obj.parentId].kids.indexOf(objId);
    var nextObj;
    if (obj.kids.length > 0 && obj.expand) { //if has kids, go to first kid
      nextObj = this.state.tree[obj.kids[0]];
      return nextObj.id;
    } else if (indexOfObjInParentsKids < this.state.tree[obj.parentId].kids.length - 1) { //if no kids, go to next sibling
      nextObj = this.state.tree[this.state.tree[obj.parentId].kids[indexOfObjInParentsKids+1]];
      return nextObj.id;
    } else {
      if (obj.parentId === this.state.viewRootId) return obj.id;
      var parent = this.state.tree[obj.parentId];
      var grandparent = this.state.tree[parent.parentId];
      var parentSiblingIndex = grandparent.kids.indexOf(parent.id);
      while (parentSiblingIndex === grandparent.kids.length - 1 ) { //if last sibling, go to parents's next kid, or parent's parents or parents parents
        if (grandparent.parentId === null) break; 
        grandparent = this.state.tree[grandparent.parentId];
        parent = this.state.tree[parent.parentId]
        parentSiblingIndex = grandparent.kids.indexOf(parent.id);
      }
      return grandparent.kids[parentSiblingIndex+1];
    }
  }

  getAllDescendents(objId) {
    return this.state.tree[objId].kids.length == 0 ? [objId] : [objId].concat(  this.state.tree[objId].kids.map(id => this.state.tree[id].kids.length == 0 ? id : this.getAllDescendents(id).flat())).flat()
  }

  moveFocusUp(objId){
    // let obj = this.state.tree[objId];
    this.setFocus(this.findNextNodeUp(objId), true, 0, 0);
  }

  moveFocusDown(objId){
    // let obj = this.state.tree[objId];
    this.setFocus(this.findNextNodeDown(objId), true, 0, 0);
  }

  setZoomObjId(objId) {
    var obj = this.state.tree[objId];
    var ancestorIds = [];
    
    while (obj.id !== this.state.tree.rootId) {
      ancestorIds.unshift(obj.id);
      obj = this.state.tree[obj.parentId];
    }
    // Filter the task list too. 

    var idsInView = this.getAllDescendents(objId);    

    this.setState({viewRootId: objId, zoomAncestorIds: ancestorIds})
  }

  //////////////////////
  //DATA MANIPULATION
  //////////////////////

  updateObj(id, obj) {
    const DELAY = 500;

    TEMP_ID = id;
    TEMP_TIME = Date.now();

    setTimeout(() => { 
      if (!(Date.now() - TEMP_TIME < DELAY && TEMP_ID === id)) {
        //Firestore Updates

        if (!this.props.demo) {
          var updates = {};
          updates[`tree.${id}`] = obj;
          firestore.doc(`users/${this.props.user.uid}`).update(updates);
        }
      }
    }, DELAY);
    
    this.setState({tree: {...this.state.tree, [id]: obj}});
  }



  indent(objId) {
    let obj = this.state.tree[objId];
    let indexOfObjInParentsKids = this.state.tree[obj.parentId].kids.indexOf(objId);
    if (indexOfObjInParentsKids > 0) {

      let fromParentId = obj.parentId;
      let toParentId = this.state.tree[fromParentId].kids[indexOfObjInParentsKids-1];

      let deleteIndex = this.state.tree[fromParentId].kids.indexOf(objId);
      let insertAt = this.state.tree[toParentId].kids.length;

      let tempTree = this.state.tree;
      tempTree[toParentId].kids.splice(insertAt, 0, objId);
      tempTree[toParentId].expand = true;
      tempTree[fromParentId].kids.splice(deleteIndex, 1);
      tempTree[objId].parentId = toParentId;

      if (!this.props.demo) {
        //Firestore Updates
        var updates = {};
        updates[`tree.${toParentId}`] = tempTree[toParentId];
        updates[`tree.${fromParentId}`] = tempTree[fromParentId];
        updates[`tree.${objId}`] = tempTree[objId];
        firestore.doc(`users/${this.props.user.uid}`).update(updates);
      }

      this.setState({tree: tempTree}) 
    }
  }

  //UPDATEE:  pull grandparentid from parentid of parentid obj (much cleaner)
  unindent(objId) {
    var obj = this.state.tree[objId];
    var parent = this.state.tree[obj.parentId];

    if (parent.parentId) {
      let tempTree = this.state.tree;

      let fromParentId = parent.id;
      let toParentId = parent.parentId;

      let deleteIndex = this.state.tree[fromParentId].kids.indexOf(objId);
      let insertAt = this.state.tree[toParentId].kids.indexOf(fromParentId)+1;

      tempTree[toParentId].kids.splice(insertAt, 0, objId);
      tempTree[fromParentId].kids.splice(deleteIndex, 1);
      tempTree[objId].parentId = toParentId;

      if (!this.props.demo) { 
        //Firestore Updates
        var updates = {};
        updates[`tree.${toParentId}`] = tempTree[toParentId];
        updates[`tree.${fromParentId}`] = tempTree[fromParentId];
        updates[`tree.${objId}`] = tempTree[objId];
        firestore.doc(`users/${this.props.user.uid}`).update(updates);
      }


      // this.forceUpdate();
      this.setState({tree: tempTree})  
    }
  }

  insert(text, belowObjId) {
    var belowObj = this.state.tree[belowObjId];
    var newId = this.state.tree.maxId + 1
    var newObj;
    var newParent;
    var newIndex;
    if (belowObj.kids.length > 0 && belowObj.expand) { //if belowObj has kids, then make new object first kid
      newObj = {id: newId, t: text, kids: [], parentId: belowObjId, isTask: false};
      newParent = this.state.tree[belowObjId];
      newParent.expand = true;
      newIndex = newParent.kids.indexOf(belowObjId);
      newParent.kids.splice(newIndex+1, 0, newId);

      if (!this.props.demo) {
        //Firestore Updates
        var updates = {};
        updates[`tree.${belowObjId}`] = newParent;
        updates[`tree.${newId}`] = newObj;
        updates[`tree.maxId`] = newId;
        firestore.doc(`users/${this.props.user.uid}`).update(updates);
      }

      this.setState({focus: true, 
                  focusObjId: newId, 
                  focusSelectionStart: 0, 
                  focusSelectionEnd: 0,
                  tree: {...this.state.tree, [newId]: newObj, [belowObjId]: newParent, maxId: newId}});
    } else { //if no kids, make it a sibling below
      newObj = {id: newId, t: text, kids: [], parentId: belowObj.parentId, expand: true, isTask: false};
      newParent = this.state.tree[belowObj.parentId];
      newIndex = newParent.kids.indexOf(belowObjId);
      newParent.kids.splice(newIndex+1, 0, newId);

      if (!this.props.demo) {
        //Firestore Updates
        var updates = {};
        updates[`tree.${belowObj.parentId}`] = newParent;
        updates[`tree.${newId}`] = newObj;
        updates[`tree.maxId`] = newId;
        firestore.doc(`users/${this.props.user.uid}`).update(updates);
      }

      this.setState({focus: true, 
                  focusObjId: newId, 
                  focusSelectionStart: 0, 
                  focusSelectionEnd: 0,
                  tree: {...this.state.tree, [newId]: newObj, [belowObj.parentId]: newParent, maxId: newId}});
    }
  }

  delete(objId) {
    var tempTree = this.state.tree;
    var obj = tempTree[objId];
    var parent = tempTree[obj.parentId];


    if (obj.kids.length === 0 && !(obj.parentId === tempTree.rootId && parent.kids.length === 1) && !("due" in obj) ) { //if no kids, ok to delete
      var nextNodeId = this.findNextNodeUp(objId)
      var nextSelectionStart = tempTree[nextNodeId].t.length;
      var deleteIndex = tempTree[obj.parentId].kids.indexOf(objId);
      tempTree[obj.parentId].kids.splice(deleteIndex, 1);
      delete(tempTree[objId])

      //Also delete object from task order array
      // var deleteTaskIndex = tempTree.nowTaskOrder.indexOf(objId)
      // if (deleteTaskIndex >= 0) {
      //   tempTree.nowTaskOrder.splice(deleteTaskIndex, 1);
      // } else {
      //   deleteTaskIndex = tempTree.laterTaskOrder.indexOf(objId)
      //     if (deleteTaskIndex >= 0) {
      //       tempTree.laterTaskOrder.splice(deleteTaskIndex, 1);
      //     }
      // }

      if (!this.props.demo) {
        //Firestore Updates
        var updates = {};
        updates[`tree.${objId}`] = firebase.firestore.FieldValue.delete();
        updates[`tree.${obj.parentId}`] = tempTree[obj.parentId]
        firestore.doc(`users/${this.props.user.uid}`).update(updates);
      }

      this.setState({ focus: true, 
                      focusObjId: nextNodeId, 
                      focusSelectionStart: nextSelectionStart, 
                      focusSelectionEnd: nextSelectionStart, 
                      tree: tempTree })   
    }
  }

  addTask(objId, date) {
    var obj = this.state.tree[objId];

    obj['due'] = new firebase.firestore.Timestamp(moment(date).unix(),0);
    obj['complete'] = false;
    obj['isTask'] = true;

    var updatedTaskLists = this.state.tree.taskLists;
    updatedTaskLists[0].taskOrder.push(objId);

    if (!this.props.demo) {
      //Firestore Updates
      var updates = {};
      updates[`tree.${objId}`] = obj;
      updates[`tree.taskLists.0.taskOrder`] = updatedTaskLists[0].taskOrder;
      firestore.doc(`users/${this.props.user.uid}`).update(updates);
    }

    this.setState({tree: {...this.state.tree, taskLists: updatedTaskLists, [objId]: obj}})
  }

  removeTask(objId) {
    var obj = this.state.tree[objId];
    var tempTaskLists = this.state.tree.taskLists;
    
    delete obj.due;
    delete obj.complete;
    
    let taskListId;
    let tempTaskListOrder;

    for (var id in tempTaskLists) {
      

      let indexOfDelete = tempTaskLists[id].taskOrder.indexOf(objId);
      if (indexOfDelete !== -1) {
        taskListId = id;
        tempTaskListOrder = tempTaskLists[id].taskOrder;
        tempTaskListOrder.splice(indexOfDelete, 1);
      }
    }

    if (!this.props.demo) {
      //Firestore Updates
      var updates = {};
      updates[`tree.${objId}`] = obj;
      updates[`tree.taskLists.${taskListId}.taskOrder`] = tempTaskListOrder;
      firestore.doc(`users/${this.props.user.uid}`).update(updates);
    }

    this.setState({tree: {...this.state.tree, 
                          taskLists: tempTaskLists,
                          [objId]: obj}, 
                  })
  }

  

  toggleComplete(objId) {
    var obj = this.state.tree[objId];
    var tempTaskLists = this.state.tree.taskLists;
    var tempCompletedTasks = this.state.tree.completedTasks;
    var modifiedTaskListId;

    if (obj.complete) { //If already complete, toggle off and remove from completed list (bring back to now)
      modifiedTaskListId = 0;
      tempTaskLists[modifiedTaskListId].taskOrder = tempTaskLists[modifiedTaskListId].taskOrder.concat([objId]); 
      tempCompletedTasks = tempCompletedTasks.filter(i => i !== objId);
      obj.completedAt = null;
    } else { //If now complete, toggle complete and move to completed list

      for (var id in tempTaskLists) {
        var indexOfDelete = tempTaskLists[id].taskOrder.indexOf(objId);
        if (indexOfDelete !== -1) {
          modifiedTaskListId = id;
          tempTaskLists[id].taskOrder = tempTaskLists[id].taskOrder.filter(i => i !== objId);
        }
      }
      tempCompletedTasks = tempCompletedTasks.concat([objId])
      obj.completedAt = new firebase.firestore.Timestamp(moment(new Date()).unix(),0);
    }

    obj.complete = !obj.complete;

    if (!this.props.demo) { 
      //Firestore Updates
      var updates = {};
      updates[`tree.${objId}`] = obj;
      updates[`tree.taskLists.${modifiedTaskListId}.taskOrder`] = tempTaskLists[modifiedTaskListId].taskOrder;
      updates[`tree.completedTasks`] = tempCompletedTasks;
      firestore.doc(`users/${this.props.user.uid}`).update(updates);
    } 


    this.setState({tree: {...this.state.tree, 
                          [objId]: obj, 
                          taskLists: tempTaskLists,
                          completedTasks: tempCompletedTasks
                         }})
  }

  toggleExpand(objId) {
    var obj = this.state.tree[objId];
    obj.expand = !obj.expand;
    this.setState({tree: {...this.state.tree, [objId]: obj}})
  }

  expand(objId) {
    var obj = this.state.tree[objId];
    obj.expand = true;
    this.setState({tree: {...this.state.tree, [objId]: obj}})
  }

  collapse(objId) {
    var obj = this.state.tree[objId];
    obj.expand = false;
    this.setState({tree: {...this.state.tree, [objId]: obj}})
  }

  collapseUpward(objId) {
    var obj = this.state.tree[objId];
    var parentObj = this.state.tree[obj.parentId];
    parentObj.expand = false;
    this.setState({tree: {...this.state.tree, [parentObj.id]: parentObj}, focusObjId: parentObj.id, focus: true, focusSelectionStart: 0, focusSelectionEnd: 0})
  }

  parentsTextArray(objId) {
    var parentsTextArray = [];
    while (this.state.tree[objId].parentId !== this.state.tree.rootId) {
      parentsTextArray.push(this.state.tree[this.state.tree[objId].parentId].t);
      objId = this.state.tree[objId].parentId;
    }
    return parentsTextArray.reverse();
  }

  handleCompletedTabChange(event, newValue) {
    this.setState({completedTabValue: newValue})
  }

  handleShowTasks(value) {
     this.setState({showTasks: value})
  }
  
  handleCompletedFilterChange(event, value) {
    this.setState({completedFilter: value})
  }

  toggleHelp() {
    this.setState({showHelp: !this.state.showHelp})
  }

  handleKeyDown(event) {
    // console.log(event.keyCode, event.metaKey)
    if ( event.keyCode===80 && event.metaKey ) { 
      this.toggleSearch();
      event.preventDefault();
      return;
    }
    if ( event.keyCode===27 && this.state.showSearch ) { 
      this.hideSearch();
      event.preventDefault();
    }


  }




  /////////////////////////
  /// Task List Editing ///
  /////////////////////////

  addTaskList() {
    let tempTree = this.state.tree;
    let newId = tempTree.maxTaskListId + 1;
    let newTaskLists = this.state.tree.taskLists;
    newTaskLists[newId] = {id: newId, name: "New List", taskOrder: []};
    let newTaskListOrder = this.state.tree.taskListOrder.concat([newId]);
    tempTree.taskLists = newTaskLists;
    tempTree.maxTaskListId = newId;
    tempTree.taskListOrder = newTaskListOrder;
    
    if (!this.props.demo) {
      //Firebase Updates
      var updates = {};
      updates[`tree.taskLists`] = newTaskLists;
      updates[`tree.maxTaskListId`] = newId;
      updates[`tree.taskListOrder`] = newTaskListOrder;
      firestore.doc(`users/${this.props.user.uid}`).update(updates);
    }
    
    this.setState({tree: tempTree})
  }

  removeTaskList(id) {
    let tempTree = this.state.tree;
    let newTaskLists = this.state.tree.taskLists;
    delete newTaskLists[id]

    let newTaskListOrder = this.state.tree.taskListOrder;
    let indexOfDelete = newTaskListOrder.indexOf(id)
    newTaskListOrder.splice(indexOfDelete, 1);

    tempTree.taskLists = newTaskLists;
    tempTree.taskListOrder = newTaskListOrder;
    
    if (!this.props.demo) {
      //Firebase Updates
      var updates = {};
      updates[`tree.taskLists`] = newTaskLists;
      updates[`tree.taskListOrder`] = newTaskListOrder;
      firestore.doc(`users/${this.props.user.uid}`).update(updates);
    }

    this.setState({tree: tempTree})
  }

  editTaskListName(taskListId, value, e) {
    this.setState({taskListEdit: taskListId, taskListEditName: value});
  }

  moveTaskListUp() {

  }

  moveTaskListDown() {
    
  }

  handleTaskListOptionsClick(tasklist, e) {
    e.preventDefault();
      contextMenu.show({
        id: tasklist,
        event: e,
      });
  }

  onBlurTaskListEditName(id, e) {
    this.saveTaskListName(id, e.target.value);
  }

  onChangeTaskListName(e) {
    this.setState({taskListEditName: e.target.value});
  }

  onTaskListInputKeyDown(id, e) {
    if (e.keyCode===13) {
      this.saveTaskListName(id, e.target.value)
    }
  }

  saveTaskListName(id, name) {
    let tempTree = this.state.tree;
    tempTree.taskLists[id].name = name;
    
    if (!this.props.demo) {
      //Firestore Updates
      var updates = {};
      updates[`tree.taskLists.${id}.name`] = name;
      firestore.doc(`users/${this.props.user.uid}`).update(updates);
    }


    this.setState({tree: tempTree, taskListEdit: null, taskListEditName: null}) 
  }

  ////////////////////////////
  // Search //////////////////
  ////////////////////////////


  toggleSearch() {
    this.setState({showSearch: !this.state.showSearch})
  }

  hideSearch() {
    this.setState({showSearch: false, searchText: "", searchResults: []})
  }

  handleSearchChange(event) {
    this.setState({searchText: event.target.value});
    this.search(event.target.value)
    
  }

  search(str) {
    //Convert object to array
    const keys = Object.keys(this.state.tree).filter(i => !isNaN(parseInt(i)) );
    const searchArray = keys.map(key => this.state.tree[key])

    //Move this outside of search to on tree change event to improve performance
    const fuse = new Fuse(searchArray, {
      keys: ['t'], threshold: 0.3
    })
    const results = fuse.search(str);
    this.setState({searchResults: results.map(i => i.item)})

  }

  getAncestorIds(obj) {
    var ancestorIds = [];
    
    while (obj.id !== this.state.tree.rootId) {
      ancestorIds.unshift(obj.id);
      obj = this.state.tree[obj.parentId];
    }
    return ancestorIds;
  }



  ////////////////////////////
  ////////////////////////////

  renderCompleted() {
    var completedTasks = this.state.tree.completedTasks.filter(id => {
      var momentObj = moment(this.state.tree[id].completedAt.toDate());
      if (this.state.completedFilter === 'today') {
        return momentObj.dayOfYear() === moment().dayOfYear() && momentObj.year() === moment().year();
      } else if (this.state.completedFilter === 'week') {
        return momentObj.week() === moment().week() && momentObj.year() === moment().year();
      } else if (this.state.completedFilter === 'month') {
        return momentObj.month() === moment().month() && momentObj.year() === moment().year();
      }
    }).map(id => this.state.tree[id]);

    return <div>
              
              <div className="CompletedFilterButtons">
                <ToggleButtonGroup
                    value={this.state.completedFilter}
                    exclusive
                    onChange={this.handleCompletedFilterChange.bind(this)}
                    aria-label="text alignment"
                    size='small'>
                      <ToggleButton value="today" aria-label="left aligned">
                        Today
                      </ToggleButton>
                      <ToggleButton value="week" aria-label="centered">
                        This Week
                      </ToggleButton>
                      <ToggleButton value="month" aria-label="right aligned">
                        This Month
                      </ToggleButton>
                    </ToggleButtonGroup>
              </div>


              {completedTasks.map(item =>  
              <div className="CompletedTask" key={item.id}>  
                <Task obj={item} 
                      parentsTextArray={this.parentsTextArray(item.id)}
                      toggleComplete={this.toggleComplete.bind(this, item.id)} />
              </div>



              )}
              
          </div>
  }


  renderTasks() {
    var taskLists = [0].concat(this.state.tree.taskListOrder).map(taskListId => this.state.tree.taskLists[taskListId])

    var idsInView = this.getAllDescendents(this.state.viewRootId);
    // var tasks = list.filter(x => idsInView.includes(x)).map(objId => this.state.tree[objId])


    return <div >
            <DragDropContext onDragEnd={this.onDragEnd}>

              {taskLists.map(taskList => 
                <React.Fragment key={taskList.id}>
                  
                  <div className={taskList.id === 0 ? "TaskListContainer Initial" : "TaskListContainer"}>
                    <div className="TaskListTopBar">
                      {this.state.taskListEdit === taskList.id ? <input className="TaskListEditInput" autoFocus onBlur={this.onBlurTaskListEditName.bind(this, taskList.id)} value={this.state.taskListEditName} onChange={this.onChangeTaskListName.bind(this)} onKeyDown={this.onTaskListInputKeyDown.bind(this, taskList.id)}/>: <h6 className="mt-1 ml-1" onClick={this.editTaskListName.bind(this, taskList.id, taskList.name)}>{taskList.name}</h6>} 
                      {taskList.id === 0 ? null : <Tooltip title="Options" placement="top">
                                                    <img className="TaskListOptionsButton "  alt="" src={ellipsis} onClick={this.handleTaskListOptionsClick.bind(this, 'task_list_menu_id'+taskList.id)} />
                                                  </Tooltip>  }
                    </div>
                    <Menu id={'task_list_menu_id'+taskList.id}>
                      <Item onClick={this.editTaskListName.bind(this, taskList.id, taskList.name)}>Edit name</Item>
                      <Item disabled onClick={this.moveTaskListUp.bind(this, taskList.id)}>Move up</Item>
                      <Item disabled onClick={this.moveTaskListDown.bind(this, taskList.id)}>Move down</Item>
                      <Item disabled={taskList.taskOrder.length > 0} onClick={this.removeTaskList.bind(this, taskList.id)}>Delete list</Item>
                    </Menu>
                    <Droppable droppableId={taskList.id.toString()}>
                    {(provided, snapshot) => (
                      <div {...provided.droppableProps} ref={provided.innerRef} className="Droppable">

                        
                        {taskList.taskOrder.filter(x => idsInView.includes(x)).map(objId => this.state.tree[objId]).map((item, index) => (
                          <React.Fragment key={"TaskF_"+item.id}>
                            <Draggable key={"Task_"+item.id} draggableId={""+item.id} index={index}>
                              {(provided, snapshot) => (
                                <div ref= {provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                          )}>
                                  <Task obj={item} 
                                        parentsTextArray={this.parentsTextArray(item.id)}
                                        toggleComplete={this.toggleComplete.bind(this, item.id)} />
                                </div>
                              )}
                            </Draggable>
                            
                          </React.Fragment>
                        ))}

                        {provided.placeholder}
                       
                        
                      </div>
                    )}
                  </Droppable>  
                </div>
              </React.Fragment>

              )}

            </DragDropContext>

            <div className="AddTaskListButton" onClick={this.addTaskList.bind(this)}>+ New list</div>
          </div>
  }




renderTree(objId) {
    var obj = this.state.tree[objId];

    return  objId === this.state.viewRootId ? this.renderTreeKids(obj) : 
              <div key={"KidWrapper"+ obj.id}>
                <Element  obj={obj} 
                          text={obj.t} 
                          key={"Element_" + obj.id} 
                          indent={this.indent.bind(this,obj.id)} 
                          unindent={this.unindent.bind(this,obj.id)}  //broke, need to fix
                          focusObjId={this.state.focusObjId} 
                          focus={this.state.focus} 
                          selectionStart={this.state.focusSelectionStart} 
                          selectionEnd={this.state.focusSelectionEnd} 
                          setFocus={this.setFocus} 
                          updateObj={this.updateObj}
                          moveFocusUp={this.moveFocusUp.bind(this,obj.id)}
                          moveFocusDown={this.moveFocusDown.bind(this,obj.id)} 
                          insert={this.insert.bind(this)} 
                          delete={this.delete.bind(this, obj.id)}
                          addTask={this.addTask.bind(this)}
                          removeTask={this.removeTask.bind(this, objId)}
                          toggleExpand={this.toggleExpand.bind(this, obj.id)}
                          expand={this.expand.bind(this, obj.id)}
                          collapse={this.collapse.bind(this, obj.id)}
                          collapseUpward={this.collapseUpward.bind(this, obj.id)}
                          toggleComplete={this.toggleComplete.bind(this, obj.id)}
                          setZoomObjId={this.setZoomObjId.bind(this, obj.id)}
                          />
                
                { obj.kids.length > 0 && obj.expand ?
                  this.renderTreeKids(obj) 
                  :
                  null
                }
              </div>

  }

  renderTreeKids(parent) {
    var kids = parent.kids.map(id => this.state.tree[id]);
    var isParentViewRoot = this.state.viewRootId === parent.id

    return  <div className={!isParentViewRoot ? "SubTree" : "SubTreeRoot"} key={"Subtree_" + parent.id}>
              { kids.map(kid => this.renderTree(kid.id)) }
            </div>
  }


  render() {


    


    return  <div className="App h-100">
              <div className="container-fluid h-100">
                <div className="row h-100">

                  <div className="col-md-4 sidebar pt-2 h-100 text-left">
                    <svg width="1.5em" height="1.5em" viewBox="0 0 16 16" className="bi bi-card-checklist mb-4" fill="rgb(131,131,131)" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" d="M14.5 3h-13a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"/>
                      <path fillRule="evenodd" d="M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0zM7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z"/>
                    </svg>
                    <div className="SignOut">{this.props.demo ? <Link to="/signup" className="SignUpLink">Sign up here</Link> : <a onClick = {() => {auth.signOut()}}>Sign Out</a>} </div>

                    <div className="SideBarHeader"><span className={this.state.showTasks ? "Selected" : null} onClick={this.handleShowTasks.bind(this, true)}>Tasks</span><span className={!this.state.showTasks ? "Selected" : null} onClick={this.handleShowTasks.bind(this, false)}>Completed</span></div>
                    


                    {this.state.tree ? (this.state.showTasks ? this.renderTasks() : this.renderCompleted() ) : null }



                    
                  </div>


                  { this.state.tree ? 

                  

                  this.state.showSearch ? 


                    <div className="col-md-8 px-3 py-3 pb-md-4 text-left Search">

                      <div className="input-group mb-3">
                        <div className="input-group-prepend">
                          <span className="input-group-text" id="basic-addon1"><SearchIcon /></span>
                        </div>
                        <input type="text"  defaultValue={this.state.searchText} autoFocus className="form-control" placeholder="Quick Search" onChange={this.handleSearchChange}/>
                      </div>


                      {this.state.searchResults.map(i => <div key={i.id}>{this.getAncestorIds(i).map((id, index, array) => <span key={id}>{this.state.tree[id].t} {index === array.length -1 ? null : " > " } </span>)}</div>)}

                    
                  </div>

                    : 

                    <div className="col-md-8 px-3 py-3 pb-md-4 text-left Tree">
                    <h6>
                      <span key={"Zoom_" + this.state.tree.rootId}>
                        <a className="HeaderLink" onClick={this.setZoomObjId.bind(this, this.state.tree.rootId)}>Home</a> 
                        {this.state.zoomAncestorIds.length > 0  ? " > " : null } 
                      </span>

                      {this.state.zoomAncestorIds.map((id, index) => (

                      <span key={"Zoom_" + id}>
                        <a className="HeaderLink" onClick={this.setZoomObjId.bind(this, id)}>{this.state.tree[id].t}</a> 
                        {index === this.state.zoomAncestorIds.length -1 ? null : " > " } 
                      </span>
                      ))}
                    </h6>

                    {this.renderTree(this.state.viewRootId)}
                  </div>
                  
                  
                  
                  : null}

                </div>
              </div>
              <div className="Help">
                <div className="HelpButton" onClick={this.toggleHelp.bind(this)} style={this.state.showHelp ? {backgroundColor: "black"} : null}>?</div>
                  {this.state.showHelp ? 
                    <div className="HelpContent">
                    <h6>Keyboard Shortcuts</h6>
                    <div className="display-block text-left">Indent <div className="float-right"><Key text="Tab" /> or <Key text="⌘" /> <Key text="]" /></div></div>
                    <div className="display-block text-left">Unindent <div className="float-right"><Key text="Shift" /> <Key text="Tab" /> or <Key text="⌘" /> <Key text="[" /></div></div>
                  </div> : null
                }

              </div>
            </div>
  }


}


export default App;